export function setLocation(location){
    return async function(dispatch){
        const action = { type : 'SET_LOCATION', payload : location}
        dispatch(action);
    }
}

